<style lang="less">
</style>

<template>
  <el-card>
    <div slot="header"></div>
    <div class="form-container">
      <el-form
        ref="ruleForm"
        :model="form"
        :rules="rules"
        label-width="135px"
        v-loading="loading"
      >
        <el-form-item label="推荐名称" prop="name">
          <el-input v-model="form.name" placeholder="推荐名称" />
        </el-form-item>

        <el-form-item label="图标" prop="path">
          <el-upload
            :action="uploadPath"
            list-type="picture-card"
            :auto-upload="true"
            :headers="uploadHeaders"
            :data="uploadImageParam"
            :accept="imageAccept"
            :beforeUpload="beforeImageUpload"
            :on-preview="imagePreview"
            :on-success="handleIconUrlSuccess"
            :on-remove="handleIconUrlRemove"
            :on-error="handleIconUrlError"
            :limit="1"
            :file-list="iconUrlList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <ec-link :form="form"></ec-link>

        <el-form-item label="选择商品">
            <el-table class="table" :header-cell-style="tableHeaderStyle" :data="form.products">
                <el-table-column  prop="name" label="商品名称">
                    <div slot-scope="scope" class="flex row">
                        <div class="margin-left-xs">
                        <div>{{ scope.row.name }}</div>
                        <div class="text-red">¥{{ scope.row.price }}</div>
                        </div>
                    </div>
                </el-table-column>
                <el-table-column align="center" label="商品图片">
                    <div slot-scope="scope">
                        <img :src="scope.row.mainFileUrl" style="height:50px"/>
                    </div>
                </el-table-column>
                <el-table-column align="center" label="操作" >
                    <template slot-scope="scope">
                    <el-link type="danger" @click="removeProduct(scope.row)">删除</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <el-button type="primary" style="margin-top:10px;" @click="showProductSelect">添加商品</el-button>
        </el-form-item>

        <el-form-item label="是否隐藏">
          <el-switch v-model="form.isHidden"></el-switch>
        </el-form-item>
        <el-form-item label="权重" prop="weight">
          <el-input type="number" v-model="form.weight" placeholder="" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>

    <ec-product-select ref="productselect" @submit="productSubmit"></ec-product-select>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </el-card>
</template>

<script>
import _ from "lodash";
import formMixin from "@/mixin/form";

export default {
  mixins: [formMixin],
  data() {
    return {
      id: null,
      loading: false,
      form: {
        title: "",
        isHidden: false,
        icon_url: "",
        products: []
      },
      rules: {
        name: this.$formHelper.requiredRuleFactory("请输入推荐名称"),
        path: [{ required: true, message: "请上传图标", trigger: "blur" }],
        weight: this.$formHelper.requiredRuleFactory("请输入权重"),
        appId: [
          { required: true, message: "请填写小程序APPID", trigger: "blur" },
        ],
        linkSrc: [
          { required: true, message: "请填写链接地址", trigger: "blur" },
        ],
      },

      dialogVisible: false,
      dialogImageUrl: "",
      iconUrlList: [],
    };
  },

  methods: {
    removeProduct(item) {
        const index = _.findIndex(this.form.products, product => {
            return product.id == item.id
        })
        if (index >= 0) {
            const form = _.cloneDeep(this.form)
            form.products.splice(index, 1)
            this.form = form   
        }
    },
    productSubmit(rows) {
        const form = _.cloneDeep(this.form)
        form.products = _.uniqBy([...form.products, ...rows ], p => p.id)
        this.form = form
    },
    showProductSelect() {
        this.$refs.productselect && this.$refs.productselect.show()
    },
    tableHeaderStyle() {
      return "color:#000;font-wight:500;font-size:16px;height:60px;background-color:#e6e9f2;";
    },
    async init() {
      const { id } = this.$route.query;
      if (id) {
        this.id = id;
        const { data = {} } = await this.$store.dispatch(
          "recommendDetail/document",
          id,
        );
        
        this.form = _.cloneDeep(data);

        if (data.path) {
          this.iconUrlList = [{ url: data.path }];
        }

        if (this.form.src) {
          this.$set(this.form, "srcType", this.form.src.srcType);
            this.$set(this.form, "appId", this.form.src.appId);
            this.$set(this.form, "linkSrc", this.form.src.linkSrc);
            this.$set(this.form, "miniType", this.form.src.miniType);
        }
      }
    },

    imagePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleIconUrlSuccess({ data = {} } = {}, file) {
      this.iconUrlList.push(file);
      this.form.path = data.url;
      this.loading = false;
    },
    handleIconUrlRemove() {
      this.iconUrlList = [];
      this.form.path = "";
      this.loading = false
    },
    handleIconUrlError(res) {
      let message = "上传失败";
      if (res && res.message) {
        try {
          message = JSON.parse(res.message).message;
        } catch (err) {}
      }
      this.$message.error(message);
      this.loading = false;
    },

    async onSubmit() {
      try {
        await new Promise((resovle, reject) => {
          this.$refs["ruleForm"].validate((valid) => {
            valid ? resovle(true) : reject(false);
          });
        });
      } catch (e) {
        return false;
      }

      try {
        let form = {
          name: this.form.name,
          path: this.form.path,
          weight: this.form.weight,
          isHidden: this.form.isHidden
        };
        if (this.form.srcType) {
          form.src = {
            srcType: this.form.srcType,
            linkSrc: this.form.linkSrc,
            appId: this.form.appId,
            miniType: this.form.miniType,
          };
        } else {
          form.src = ''
        }
        let product_ids = []
        this.form.products.forEach(item => {
            product_ids.push(item.id)
        })
        form.product_ids = product_ids
        this.loading = true;
        if (this.id) {
            form.id = this.id
          await this.$store.dispatch("recommends/update", form);
          this.$message.success("编辑成功");
        } else {
          await this.$store.dispatch("recommends/create", form);
          this.$message.success("添加成功");
        }
        this.loading = false;
        this.$router.push("/product/recommends-list");
      } catch (error) {
        this.$message.error(error.response.data.message);
        this.loading = false
      }
    },
  },

  async mounted() {
    await this.init();
  },
};
</script>